import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=fa985c40&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=fa985c40&prod&lang=less"
import style1 from "./AdminHeader.vue?vue&type=style&index=1&id=fa985c40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa985c40",
  null
  
)

export default component.exports